import { spacing } from "@minuthq/meatball-ui-react"

import { TSettingContainerOnSaveReturnType } from "src/components/Settings/Setting/SettingContainer"
import { SettingToggle } from "src/components/Settings/Setting/SettingToggle"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { usePatchOrganization } from "src/data/organizations/queries/organizationQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { DefaultBox } from "src/ui/Layout/DefaultBox"
import { MCard } from "src/ui/MCard/MCard"
import { ErrorService } from "src/utils/ErrorService"

export function AiAssistantSettings() {
  const { tPlaceholder } = useTranslate()
  const { org, orgId } = useOrganization()
  const patchOrganization = usePatchOrganization()

  async function toggleAutopilot(
    newValue: boolean
  ): TSettingContainerOnSaveReturnType {
    try {
      await patchOrganization.mutateAsync({
        orgId,
        body: { ai_auto_reply_enabled: newValue },
      })

      return {
        isSuccess: true,
      }
    } catch (error) {
      ErrorService.captureException("Failed to save autopilot enabled setting")

      return {
        isSuccess: false,
      }
    }
  }

  return (
    <DefaultBox size="small">
      <MCard border boxShadow={false} padding={spacing.L}>
        <SettingToggle
          title={tPlaceholder("Autopilot")}
          description={tPlaceholder(
            "Allow Autopilot to automatically reply to guest messages. When disabled, your team will handle all replies manually. Unresolved conversations won't be closed, and it won't reply to those already marked as resolved."
          )}
          onSave={toggleAutopilot}
          value={org.ai_auto_reply_enabled ?? false}
          hasError={patchOrganization.isError}
          disabled={patchOrganization.isLoading}
        />
      </MCard>
    </DefaultBox>
  )
}
